import { Component } from '@angular/core';

@Component({
    selector: 'sgt-cnae-indicador-secundaria-badge',
    templateUrl: './cnae-indicador-secundaria-badge.component.html',
    styleUrls: ['./cnae-indicador-secundaria-badge.component.less']
})
export class CNAEIndicadorSecundariaBadgeComponent { }
